﻿import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { GlobalService } from '../services/global.service';
import { conditionallyCreateMapObjectLiteral } from '@angular/compiler/src/render3/view/util';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  userForm = new FormGroup({ email: new FormControl('') })
  passwordResetSuccessfully = false;
  message = '';
  loading = false;

  constructor(private fb: FormBuilder, private router: Router, public Global: GlobalService) { }

  ngOnInit() {
    this.userForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      recaptcha: new FormControl(null, Validators.required)
    });
  }

  onSubmit() {
    this.loading = true;
    console.log('here i am');
        
    const body = { Username: this.userForm.controls['email'].value }

    console.log('body', body);
    
    this.Global.post("CoreRegistration/ForgotPassword", body)
    .subscribe(response => { 
      console.log('response', response);
        if(response){          
            this.message = "An email was sent to the email address on your account. Please follow the instructions in the email to reset your password.";        
        }else if(!response){
            this.message = "There seemed to be an issue; For security reasons, we did not proceed with the password reset.";
        }else{
            this.message = response; //message from server
        }

        this.loading = false;
    });

}

register() {
  this.router.navigate(['/register'])
}

  // onSubmit(form: FormGroup) {
  //   console.log('here i am');
  //   if (this.userForm.valid) {
  //     const body = { Username: this.userForm.controls['email'].value }

  //     this.Global.post("CoreRegistration/ForgotPassword", body)
  //       .subscribe(response => {
          
  //         this.passwordResetSuccessfully = true;
  //         this.handleRedirect();
  //       });
  //   } else {
  //     this.passwordResetSuccessfully = false;
  //     this.message = 'There was an error with your request. Please reach out to support for assistance.';
  //   }
  // }

  // handleRedirect() {
  //   setTimeout(() => {
  //     this.router.navigate(['/login']);
  //   }, 10000);
  // }
}
